import BlockGen from "@/features/triangle-rewards/classes/BlockGen";
import WeatherEvents from "@/features/weather/WeatherEvents.vue";
import PersonalizationApi from "@/features/offers/api/PersonalizationApi";

export default (pages, pagesIndex,insertPageNum,unitWidth, unitHeight, storeId, bannerId,lang) => {
  let weatherEventsData = null;
  let fetchAttempted = false;

  const fetchData = async () => {
    if (weatherEventsData || fetchAttempted) return;
    fetchAttempted = true;
    try {
     const data = await PersonalizationApi.GetWeatherPromos(storeId, bannerId,lang,true);
      weatherEventsData = data;

      if (!Array.isArray(data.alerts)) return;
    } catch (e) {
      return null;
    }
  };
  const fetchProductsForAlert = (alert) => {
    const result = [];
    const finelineNMs = alert?.finelineNMs?.map((f) => f.toLowerCase());
    pages.find((page) => {
      page?.blocks?.find((block) => {
        block?.products?.find((product) => {
          const categories = product?.categories;
          if (!categories || !Array.isArray(categories) || categories.length === 0) {
            return false;
          }
          const lastcategory = categories[categories.length - 1];
          const lowerCase = lastcategory?.toLowerCase();
          if (finelineNMs?.includes(lowerCase)) {
            if (product.productImage) {
              result.push(product);
            }
          }
        });
      });
    });

    return result;
  };

  const generatePage = async () => {
    if (!weatherEventsData) {
      await fetchData();
    }
    const horizontalMode = document.querySelector( '#app [flyer-orientation="horizontal"]' );
    const isDesktop = () => window.innerWidth >= 1024;
    let adjustedUnitWidth = isDesktop() && horizontalMode ? unitWidth + 40 : unitWidth;
    // CTCDF-2294 - remove cold warning from triggering promo pages
    const alerts = weatherEventsData?.weatherInfo.alerts.filter( alert => !alert.category.toUpperCase().includes("COLD") && alert.event.toUpperCase() !== "FROST") || [];
    const isAlerts = alerts.length !== 0;
    const sortedAlerts = [...alerts].sort((a, b) => a.priority - b.priority);
    const uniquePriorities = [ ...new Set(sortedAlerts.map((alert) => alert.priority)),
    ];
   

    const pageList = [];
    let firstAlertData, secondAlertData = null;
    let firstProducts, secondProducts;
    if (isAlerts) {
      const [firstAlert] = sortedAlerts.filter((a) => a.priority === uniquePriorities[0]);
      const [secondAlert] = sortedAlerts.filter((a) => a.priority === uniquePriorities[1]);

      firstProducts = fetchProductsForAlert(firstAlert);
      secondProducts = fetchProductsForAlert(secondAlert);

      firstAlertData = {
        ...weatherEventsData,
        weatherInfo: {
          ...weatherEventsData.weatherInfo,
          alerts: [firstAlert],
        },
        products: firstProducts,
      };

      if (uniquePriorities.length >= 2) {
        secondAlertData = {
          ...weatherEventsData,
          weatherInfo: {
            ...weatherEventsData.weatherInfo,
            alerts: [secondAlert],
          },
          products: secondProducts,
        };
      }
    }

    if (firstProducts?.length && isAlerts && firstAlertData) {
      const weatherEventsPage = {
        id: "weatherEvents",
        publicationId: "weatherEvents",
        name: "weatherEvents",
        props: { weatherEventsData: firstAlertData },
        data: firstAlertData,
        width: 0,
        height: 0,
        isAdPage: false,
        disclaimer: null,
        unitWidth: adjustedUnitWidth,
        unitHeight: unitHeight,
        countTowardsPageCount: false,

        grids: {
          desktop: {
            rowCount: 4,
            colCount: 3,
          },
          tablet: {
            rowCount: 1,
            colCount: 3,
            fitCols: 5,
            style: {
              fontSize: "13px",
            },
          },
          mobile: {
            rowCount: 3,
            colCount: 2,
            fitCols: 3,
            style: {
              fontSize: "13px",
            },
          },
        },
        blocks: [
          BlockGen.GenBlock(
            3,
            4,
            unitWidth,
            unitHeight,
            {},
            {
              id: "weatherEvents",
              type: "component",
              component: WeatherEvents,
              props: { weatherEventsData: firstAlertData },
            }
          ),
        ],
      };
      pageList.push(weatherEventsPage);
    }

    let weatherIndex = pages.findIndex(p =>p.id.includes('weatherPromos'))

    if (secondProducts?.length &&isAlerts && weatherIndex === -1 && secondAlertData) {
      const weatherEventsPageTwo = {
        id: "weatherEventsPageTwo",
        publicationId: "weatherEventsPageTwo",
        name: "weatherEventsPageTwo",
        props: { weatherEventsData: secondAlertData },
        data: secondAlertData,
        width: 0,
        height: 0,
        isAdPage: false,
        disclaimer: null,
        unitWidth: adjustedUnitWidth,
        unitHeight: unitHeight,
        countTowardsPageCount: false,

        grids: {
          desktop: {
            rowCount: 4,
            colCount: 3,
          },
          tablet: {
            rowCount: 1,
            colCount: 3,
            fitCols: 5,
            style: {
              fontSize: "13px",
            },
          },
          mobile: {
            rowCount: 3,
            colCount: 2,
            fitCols: 3,
            style: {
              fontSize: "13px",
            },
          },
        },
        blocks: [
          BlockGen.GenBlock(
            3,
            4,
            unitWidth,
            unitHeight,
            {},
            {
              id: "weatherEventsPageTwo",
              type: "component",
              component: WeatherEvents,
              props: { weatherEventsData: secondAlertData },
            }
          ),
        ],
      };
      pageList.push(weatherEventsPageTwo);
    }

    const idsToReplace = ["weatherEvents", "weatherEventsPageTwo"];
    for (let i = pages.length - 1; i >= 0; i--) {
      if (idsToReplace.includes(pages[i].id)) {
        pages.splice(i, 1);
      }
    }

  
    if (weatherIndex !== -1 ) {
      const weatherEventsPage = pageList.find(p => p.id.includes("weatherEvents"))
      if (weatherEventsPage) {
        pages.splice(weatherIndex + 1,0, weatherEventsPage)
      }
    } else {
       pages.splice(pagesIndex[insertPageNum], 0, ...pageList);
    }
  };

  generatePage();
  window.addEventListener("resize", generatePage);
  window.addEventListener("click", generatePage);
};
